var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71411 8.54166L4.9465 6.40714C5.23805 5.90186 5.06518 5.25574 4.5599 4.96419C4.05462 4.67264 3.40848 4.84552 3.11693 5.3508L1.70848 7.79025C0.250027 10.3163 1.11552 13.5466 3.64158 15.005C6.16763 16.4635 9.39791 15.598 10.8564 13.0719L13.6733 8.19306C13.9648 7.68778 13.7919 7.04165 13.2867 6.7501C12.7814 6.45855 12.1352 6.63144 11.8437 7.13672L10.2592 9.88109L12.9 5.30714C13.1916 4.80186 13.0187 4.15573 12.5134 3.86418C12.0081 3.57263 11.362 3.74552 11.0705 4.25081L8.78173 8.21489L9.13384 7.60503L11.7747 3.03108C12.0662 2.5258 11.8933 1.87968 11.3881 1.58813C10.8828 1.29658 10.2367 1.46946 9.94512 1.97475L7.30427 6.5487L6.95216 7.15855L9.593 2.58461C9.88455 2.07933 9.71166 1.4332 9.20637 1.14165C8.70109 0.850098 8.05496 1.02299 7.76341 1.52827L5.12256 6.10221",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.626c09eccfdc6246c52abb120c715b34.svg";
export { ForwardRef as ReactComponent };